module.exports = __webpack_public_path__ + "images/pages/halloween_lp/MV_BgStripe_364201a465f88ec06976164b10f50380.png";